<template>
  <div class="flex items-center">
    <p>{{ fixDate }}</p>
  </div>
</template>

<script>
export default {
  name: 'CellRendererDate',
  computed: {
    fixDate () {
      return this.params.value ? this.readableDate : 'N/A'
    },
    readableDate () { return new Date(this.params.value).toLocaleDateString() }
  }
}
</script>
